export const testSelectionSet = [
  "id",
  "submission.answer.correct",
  "submission.answer.id",
  "submission.createdAt",
  "createdAt",
  "questionId",
  "userRequested",
] as const;
